import { render, staticRenderFns } from "./ExistingPolicies.vue?vue&type=template&id=71240ba8"
import script from "./ExistingPolicies.vue?vue&type=script&lang=js"
export * from "./ExistingPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports